import {Component, Input, OnInit} from "@angular/core";
import {BusService} from "../../services/bus.service";
import {ModalService} from "../../services/modal.service";
import {WatchService} from "../../services/watch.service";
import {ProfileService} from "../../services/profile.service";
import {IDocument} from "../../interfaces/document.definition";

@Component({
  selector: 'nv-profile-controls',
  templateUrl: './nv-profile-controls.component.html',
  styles: []
})
export class NvProfileControlsComponent implements OnInit {
  document: IDocument;
  hasChanges: boolean = false;

  @Input() showDelete: boolean = true;

  constructor(private busService: BusService,
    private profileService:ProfileService,
    private watchService: WatchService,
    private modalService: ModalService) {
  }

  ngOnInit() {
    this.busService.onDocumentUpdated
      .subscribe(e => this.document = e.document);

    this.watchService.docChanged()
      .subscribe(hasChanges => {
        this.hasChanges = hasChanges;
      });
  }


  onJsonClick() {
    this.modalService.showJson(this.document);
  }


  onRemoveClick() {
    this.profileService.remove();
  }


  onSaveClick() {
    this.profileService.save();
  }


  onResetClick() {
    this.profileService.reset();
  }
}



// WEBPACK FOOTER //
// /opt/app/develop/src/app/components/nv-profile-controls/nv-profile-controls.component.ts